import React, { Fragment } from 'react';
import styled from 'styled-components';

import peaceWithHeart from '@front/common/src/assets/images/peace_with_heart.png';
import peaceWithHeart2x from '@front/common/src/assets/images/peace_with_heart@2x.png';
import peaceWithHeart3x from '@front/common/src/assets/images/peace_with_heart@3x.png';
import hourGlass from '@front/common/src/assets/images/hourglass.png';
import hourGlass2x from '@front/common/src/assets/images/hourglass@2x.png';
import hourGlass3x from '@front/common/src/assets/images/hourglass@3x.png';

import { translate } from '@front/i18n';

import Modal, { ModalContent } from '@front/web-ui/src/components/modal/modal';
import StickerItem from '@front/web-ui/src/components/sticker-item/sticker-item';
import Separator from '@front/web-ui/src/components/separator/separator';
import Alert from '@front/web-ui/src/components/alert/alert';
import { useIsMobile } from '@front/web-ui/src/styles/media-queries';

const t = translate('screens.instant_tax_credit_selection.what_is_tax_credit_modal');

const Column = styled.div<{ $hasSmallGap: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $hasSmallGap }) => ($hasSmallGap ? '10px' : '25px')};
  padding-top: ${({ $hasSmallGap }) => ($hasSmallGap ? '10px' : '25px')};
`;

const StyledModalContent = styled(ModalContent)`
  display: flex;
  flex-direction: column;
`;

const StyledAlert = styled(Alert)`
  margin-top: 20px;
`;

type WhatIsTaxCreditModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const images = () => ({
  full_payment_refund_later: {
    alt: t('.items.full_payment_refund_later.image_alt'),
    double: hourGlass2x,
    src: hourGlass,
    text: t('.items.full_payment_refund_later.content'),
    title: t('.items.full_payment_refund_later.title'),
    triple: hourGlass3x,
  },
  easy_to_declare: {
    alt: t('.items.easy_to_declare.image_alt'),
    double: peaceWithHeart2x,
    src: peaceWithHeart,
    text: t('.items.easy_to_declare.content'),
    title: t('.items.easy_to_declare.title'),
    triple: peaceWithHeart3x,
  },
});

const WhatIsTaxCreditModal = ({ isOpen, onClose }: WhatIsTaxCreditModalProps) => {
  const isMobile = useIsMobile();
  return (
    <Modal
      title={t('.title')}
      isOpen={isOpen}
      onClose={onClose}
      primaryButton={{
        children: t('base.got_it'),
        onPress: onClose,
      }}
    >
      <StyledModalContent>
        <Column $hasSmallGap={isMobile}>
          {Object.entries(images()).map(([key, value]) => (
            <Fragment key={key}>
              <StickerItem {...value} />
              <Separator />
            </Fragment>
          ))}
        </Column>
        <StyledAlert type='info' content={t('.alert')} />
      </StyledModalContent>
    </Modal>
  );
};

export default WhatIsTaxCreditModal;
